(function ($) {

    $.fn.definitionTooltip = function () {
        const showText = 'show-text';
        const longText = 'long-text';
        const alignRight = 'align-right';

        this.each((i, el) => {
            const $self = $(el);
            
            $self.on('click', (e) => {
                const $definitionTooltip = $(e.target);
                const currentBreakpoint = window.currentBreakpoint();
                
                if($definitionTooltip.hasClass('fr-definition-tooltip')){
                    if(!$definitionTooltip.hasClass(showText)){
                        hideAllTooltips();
                        reset($definitionTooltip);
                        $definitionTooltip.addClass(showText);
                        checkTextWidth($definitionTooltip);
                        repositionTooltip($definitionTooltip, ['xs', 'sm'].includes(currentBreakpoint));
                    }else{
                        reset($definitionTooltip);
                    }
                }

                //clase  tooltip
                $('body').find('.fr-custom-tooltip.show-text').each(function (index, domEle) {
                    $(domEle).removeClass('show-text');
                });
            });

            $self.find('.tooltip-text').on('click', (e) => {
                const $tooltipText = $(e.target);
                const $tooltip = $tooltipText.parent('.fr-definition-tooltip');
                reset($tooltip);            
            });
        });

        function checkTextWidth($definitionTooltip){
            const $text = $definitionTooltip.find('.tooltip-text');
            if($text[0].scrollWidth > $text[0].clientWidth){
                $text.addClass(longText);
            }
            $text.addClass('visible');
        }

        function repositionTooltip($definitionTooltip, isMobile = false){
            const $definitionTooltipText = $definitionTooltip.find('.tooltip-text');
            if(isMobile){
                const offset = $definitionTooltipText.offset().left;
                offset < 0 ? $definitionTooltipText.css('right', offset - (15 / 2)) : $definitionTooltipText.css('left', offset);
            }else{
                if($definitionTooltipText.offset().left < $('.entry-content').offset().left){
                    $definitionTooltipText.addClass(alignRight);
                }
            }
        }

        function reset($definitionTooltip){
            $definitionTooltip.removeClass(showText);
            $definitionTooltip.find('.tooltip-text').attr('style', '');
            $definitionTooltip.find('.tooltip-text').removeClass(alignRight);
            $definitionTooltip.find('.tooltip-text').removeClass(longText);
        }

        function hideAllTooltips(){
            $('.fr-definition-tooltip').removeClass(showText);
            $('.fr-definition-tooltip').find('.tooltip-text').removeClass(alignRight);
            $('.fr-definition-tooltip').find('.tooltip-text').removeClass(longText);
        }

        return this;
    }

    $(() => {
        $('.fr-definition-tooltip').definitionTooltip();
    });

})($);


// WEBPACK FOOTER //
// ./scripts/components/definition-tooltip.js